import React from 'react';
import { GBChips } from '@leapfinance/geebee-component-library';
import { Tooltip } from '@mui/material';
import { disabledOption } from '../utils';
import MultiSelectFilter from './MultiSelectFilter';
import useCFFilters from './useCFFilters';
var IntakeCfFilter = function (props) {
    var _a = useCFFilters({}), getIntakeOptions = _a.getIntakeOptions, intakeValues = _a.intakeValues;
    var options = getIntakeOptions(props.intakeData, props === null || props === void 0 ? void 0 : props.popularIntakes);
    return (React.createElement(MultiSelectFilter, { label: "Intake", options: options, getOptionDisabled: disabledOption, onApply: function (values) {
            props === null || props === void 0 ? void 0 : props.handleFilterApply({ name: props === null || props === void 0 ? void 0 : props.name, value: values });
        }, values: intakeValues, optionEndItem: function (option) {
            return (option === null || option === void 0 ? void 0 : option.isPopular) ? (React.createElement(Tooltip, { title: "Popular intake" },
                React.createElement(GBChips, { variant: "primary", title: "Popular Intake" }))) : null;
        } }));
};
export default IntakeCfFilter;
//# sourceMappingURL=IntakeCfFilter.js.map